<template>
  <el-aside width="201px" class="tableNav nice_scroll">
    <!-- 写信/收信 -->
    <el-row class="flexBetween doubleBtns">
      <el-button size="small" type="primary" icon="el-icon-asideEdit" @click="gotolink">{{$t("wm_lang_html_cecc29")}}</el-button>
      <el-button size="small" type="primary" icon="el-icon-asideMail" @click="mailReceive">{{$t("wm_lang_html_ef801d")}}</el-button>
    </el-row>
    <div class="treeAside">
      <el-tree :data="folderList" ref="folderTree" icon-class="el-icon-arrow-right" node-key="folderId" :props="defaultProps" accordion @node-click="handleNodeClick">
      <span class="custom-tree-node flexCenter" slot-scope="{ node, data }">
        <!--<i :class="getFolderIcon(data.folderId)"></i>-->
        <span class="ellipsis max100 title">{{ folderDisplayName(node) }}</span>
        <span class="nums" v-if="data.unseenCount !== 0">{{ data.unseenCount }}</span>
        <span class="nums" v-if="data.folderId === starFolderNo && data.mailCount !== 0">{{ data.mailCount }}</span>
      </span>
      </el-tree>
    </div>
    <div class="menuAside" v-if="largeAttachPriv">
      <el-menu
        ref="largeAttachMenu"
        background-color="transparent"
        text-color="#23314d"
        active-text-color="#3986ee">
        <el-menu-item index="1" @click="goLargeAttach" style="padding-left:0px!important;">
          <!-- <i class="el-icon-menu"></i> -->
          <i class="" style="width:20px;display:inline-block;">&nbsp;</i>
          <span slot="title">{{$t("wm_lang_html_46042d")}}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!--<el-menu-->
      <!--ref="elMenu"-->
      <!--class="ztree"-->
      <!--@open="handleOpen"-->
      <!--@select="handleSelect"-->
      <!--:unique-opened="true"-->
      <!--:default-active="folderId"-->
      <!--background-color="#f5f6f7"-->
      <!--@close="handleClose">-->
      <!--<folderMenu :folders="folderList"></folderMenu>-->
      <!--<el-submenu index="9999">-->
        <!--<template slot="title">-->
          <!--<router-link to="">-->
            <!--<i class="icon el-icon-serviceEmail"></i>-->
            <!--<span>{{$t("wm_lang_html_7b4a28")}}</span>-->
          <!--</router-link>-->
        <!--</template>-->
        <!--&lt;!&ndash;<el-menu-item-group>&ndash;&gt;-->
        <!--<el-menu-item index="9-1"><router-link to="#">{{$t("wm_lang_html_46042d")}}</router-link></el-menu-item>-->
        <!--<el-menu-item index="9-2"><router-link target="_blank" to="#">{{$t("wm_lang_html_043897")}}</router-link></el-menu-item>-->
        <!--&lt;!&ndash;</el-menu-item-group>&ndash;&gt;-->
        <!--<el-submenu index="9-3">-->
          <!--<template slot="title">{{$t("wm_lang_html_3d448d")}}</template>-->
          <!--<el-menu-item index="9-3-1"><router-link to="#">{{$t("wm_lang_html_26f9bf")}}1</router-link></el-menu-item>-->
          <!--<el-menu-item index="9-3-2"><router-link to="#">{{$t("wm_lang_html_26f9bf")}}2</router-link></el-menu-item>-->
        <!--</el-submenu>-->
      <!--</el-submenu>-->
    <!--</el-menu>-->
    <!-- 新建文件夹/设置 -->
    <el-row class="leftEditLink flexCenter">
      <el-link :underline="false" icon="el-icon-circle-plus-outline" :title="$i18n.t('wm_lang_f3a485')" @click="addFolderDialog"></el-link>
      <router-link :to="{name: 'setting', params: {activeIndex: '4'}}">
        <el-link :underline="false" icon="el-icon-setting" :title="$i18n.t('wm_lang_e366cc')"></el-link>
      </router-link>
    </el-row>
    <!-- 新建文件夹模态框 -->
    <!--<el-dialog title=this.$i18n.t('wm_lang_f3a485') :visible.sync="dialogFormVisible" width="36%">-->
      <!--<el-form :model="form">-->
        <!--<el-form-item label=this.$i18n.t('wm_lang_a98473') :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.name" autocomplete="off" placeholder=this.$i18n.t('wm_lang_5df03b')></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label=this.$i18n.t('wm_lang_22b234') :label-width="formLabelWidth">-->
          <!--<el-select v-model="form.folder" placeholder=this.$i18n.t('wm_lang_c2b9f4')>-->
            <!--<el-option label=this.$i18n.t('wm_lang_c2b9f4') value="folder1"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_e75969') value="folder2"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_93d159') value="folder3"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_5cc232') value="folder4"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_22b433') value="folder5"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_0bb8f9') value="folder6"></el-option>-->
            <!--<el-option label=this.$i18n.t('wm_lang_c3ba16') value="folder7"></el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="dialogFormVisible = false">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>-->
        <!--<el-button type="primary" @click="dialogFormVisible = false">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>-->
      <!--</div>-->
    <!--</el-dialog>-->
    <el-dialog :title="$i18n.t('wm_lang_f3a485')" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="520px">
      <el-form :model="form" :rules="rules" ref="ruleForm" class="form-setting">
        <el-form-item :label="$i18n.t('wm_lang_a98473')" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :placeholder="$i18n.t('wm_lang_5df03b')"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_22b234')" :label-width="formLabelWidth">
          <el-select v-model="belongFolder" :placeholder="$i18n.t('wm_lang_c2b9f4')" style="max-width:270px;">
            <el-option :label="$i18n.t('wm_lang_c2b9f4')" :value="0"></el-option>
            <el-option v-for="(item, index) in form.folders" :key="index" :label="item.displayName" :value="item.folderId" style="width:270px;"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
      </div>
    </el-dialog>
  </el-aside>
</template>

<script>
  import Cookies from 'js-cookie';
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { bitIs1, getFolderPathName } from '@/utils/utils';
  // import { makeFolderList } from '@/api/folder';
  // import folderMenu from '@/components/sub/folderMenu';
export default {
  name: 'Aside',
  data () {
    let folderNameVerify = (rule, value, callback) => {
      let reg = /[\/\:\*\?\"\<\>\|\ \\\+\']+/g;
      if (value.match(reg)) {
        callback(new Error(this.$i18n.t('wm_lang_6f67c4')+"\\ \/ \: \* \? \" \< \> \| \+ \' "+ this.$i18n.t('wm_lang_html_fcbc6a')));
      } else {
        //
        callback();
      }
    };
    return {
      msgindex: this.$i18n.t('wm_lang_8e22f1'),
      // 设置代办
      dialogFormVisible: false,
      localConfigSetting: '',
      largeAttachPriv: false,
      starFolderNo: 64,
      form: {
        name: '',
        folders: []
      },
      belongFolder: 0,
      formLabelWidth: '140px',
      folderList: [],
      folderOrg: [],
      folderId: '',
      defaultProps: {
        children: 'children',
        label: 'displayName'
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('wm_lang_47631c'), trigger: 'blur' },
          { max: 64, message: this.$i18n.t('wm_lang_379b24')+'64'+this.$i18n.t('wm_lang_15d410'), trigger: 'blur' },
          { validator: folderNameVerify, trigger: 'blur' }
        ]
      }
    };
  },
  // components:{
  //   folderMenu
  // },
  methods: {
    addFolderDialog() {
      this.dialogFormVisible = true;
      this.form.name = '';
      this.belongFolder = 0;
    },
    goLargeAttach() {
      // this.folderList.forEach(ele=>{
      //   this.$nextTick(()=>{
      //     console.log(ele.folderId)
      //     this.$refs.folderTree.setChecked(ele.folderId, false, true);
      //   })
      // });
      this.$nextTick(()=>{
        this.$refs.folderTree.setCurrentKey(null);
      });
      this.$router.push({name: 'largeAttach'});
    },
    getFolderIcon(id) {
      switch(id) {
        case 1:
          return 'icon el-icon-email'
          break;
        case 65:
          return 'icon el-icon-agentEmail'
          break;
        case 64:
          return 'icon el-icon-starEmail'
          break;
        case 2:
          return 'icon el-icon-sentEmail'
          break;
        case 3:
          return 'icon el-icon-delEmail'
          break;
        case 4:
          return 'icon el-icon-draftEmail'
          break;
        case 5:
          return 'icon el-icon-spamEmail'
          break;
        case 10:
          return 'icon el-icon-archivedEmail'
          break;
        case 16:
          return 'icon el-icon-email'
          break;
        default:
          return ''
      }
    },
    folderDisplayName(node) {
      if(node.data.folderId === xmail.enums.FolderType.STAR_BOX_FOLDER_ID) {
        return this.$i18n.t('custom_lang_0069')
      } else {
        return node.label
      }
    },
    handleNodeClick(data) {
      // this.$refs.largeAttachMenu.activeIndex = null;
      // console.log(data);
      // this.$store.state.folder.folderId = data.folderId;
      this.$store.commit('SET_FOLDER_ID',data.folderId);
      this.$store.commit('SET_FOLDER_NAME',data.folderId !== xmail.enums.FolderType.STAR_BOX_FOLDER_ID ? data.displayName : this.$i18n.t('custom_lang_0069'));
      if(this.$refs.largeAttachMenu) {
        this.$refs.largeAttachMenu.activeIndex = null;
      }
      // console.log(this.$store.state.folder.folderId);
      // console.log(this.$route.name);
      if(this.$route.name !== 'read') {
        if(this.$route.name === 'newRead' || this.$route.name === 'write') {
          this.$EventBus.$emit("getCurrFid",{folderId: data.folderId});
          this.$EventBus.$emit("cancelListCheckAll");
          this.$router.push({name: 'read'});
        } else {
          this.$router.push({name: 'read', params: {first: true, fid: data.folderId}});
        }
      } else {
        this.$EventBus.$emit("getCurrFid",{folderId: data.folderId});
        this.$EventBus.$emit("cancelListCheckAll");
      }
      // this.$EventBus.$emit("getCurrFid",data.folderId)
      // this.$router.push({name:'read', params: {fid: data.folderId}})
      this.syncFolderHighlight(data.folderId);
    },
    mailReceive() {
      this.$nextTick(()=>{
        this.$refs.folderTree.setCurrentKey(xmail.enums.FolderType.RECEIVE_BOX_FOLDER_ID);
      });
      if(this.$refs.largeAttachMenu) {
        this.$refs.largeAttachMenu.activeIndex = null;
      }
      this.$store.commit('SET_CHECKED_MAILS',[]);
      this.$store.commit('SET_FOLDER_ID',xmail.enums.FolderType.RECEIVE_BOX_FOLDER_ID);
      this.$store.commit('SET_FOLDER_NAME',this.$i18n.t('wm_lang_e75969'));
      this.$EventBus.$emit("getCurrFid", {folderId: xmail.enums.FolderType.RECEIVE_BOX_FOLDER_ID});
      this.$router.push({name: 'read'});
      this.getFolders();
    },
    gotolink(){
      //指定跳转地址
      // this.$router.replace('/home/write')
      if(this.$route.name !== 'write') {
        this.$EventBus.$emit("closeWritePage", {type: 'common'});
        this.$router.push({name: 'write', params: {type: 'write'}});
        this.$EventBus.$emit("closeSentPage");
      } else {
        this.$EventBus.$emit("againInitWrite");
      }
      // this.$router.push({name: 'write', params: {type: 'write'}});
      // this.$EventBus.$emit("closeSentPage");
    },
    filterFolderMenu(data, parent) { //文件夹菜单数据构造
      const tree = [];
      if (!data.length) {
        return [];
      }
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentFolderId === parent) {
          const obj = data[i];
          temp = this.filterFolderMenu(data, data[i].folderId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    getFolders() {
      let self = this;
      (function (api, enums, pms) {
        api.Folder.getFolderList({}, function (res) {
          // console.log(res)
          if(res.data.code === 0) {
            const list = res.data.data.mailFolders;
            self.$store.commit('SET_FOLDERS',list);
            self.folderOrg = list;
            let folderList = self.filterFolderMenu(list, 0);
            self.folderList = folderList;
            let foldersArr = JSON.parse(JSON.stringify(self.$store.getters.folders));
            foldersArr = foldersArr.filter(item => item.folderId !== enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== enums.FolderType.WAITING_BOX_FOLDER_ID && item.folderId !== enums.FolderType.BACKUP_BOX_FOLDER_ID);
            self.form.folders = getFolderPathName(foldersArr);
            self.syncFolderHighlight(self.$store.getters.folderId);
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    syncFolderHighlight(currFid) {
      //高亮文件夹节点
      let nodes = this.$refs.folderTree.store.nodesMap;
      for (let n in nodes) {
        this.$nextTick(() => {
          nodes[n].isCurrent = false
        });
      }
      for (let i in nodes) {
        if (currFid === nodes[i].data.folderId) {
          this.$nextTick(() => {
            nodes[i].isCurrent = true;
            nodes[i].parent.expand();
          });
        }
      }
    },
    submitForm(formName) {
      // console.log(this.currFolder);
      // console.log(this.belongFolder );
      // console.log(this.form.folders);
      // console.log(this.folderOrg);
      let sameParentFolders = [];
      let existSame = false;
      this.folderOrg.forEach(item =>{
        if(item.parentFolderId === this.belongFolder) {
          sameParentFolders.push(item);
        }
      });
      // console.log(sameParentFolders);
      sameParentFolders.forEach(item =>{
        let fName = item.displayName.split('/').pop();
        if(fName === this.form.name) {
          existSame = true;
        }
      });
      if(existSame) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_ea8b1d')+','+this.$i18n.t('wm_lang_5d44d9')
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.Folder.addFolderParamBuilder();
            pm.name = self.form.name;
            pm.parentFolderId = self.belongFolder;
            api.Folder.addFolder(pm, function (res) {
              self.getFolders();
              if(res.data.code === 0) {
                self.form.name = '';
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_3fdaea')+'!'
                });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields();
    },
    initFolder() {
      this.localConfigSetting = storeLocal.get('Pwm-configSetting');
      // 超大附件权限处理
      this.largeAttachPriv = bitIs1(this.localConfigSetting.priviage.priviage1, 6);
      this.starFolderNo = xmail.enums.FolderType.STAR_BOX_FOLDER_ID;
      this.getFolders();
      //刷新文件夹的eventBus
      let self = this;
      this.$EventBus.$off("refreshFolders");
      this.$EventBus.$on("refreshFolders",function(){
        self.getFolders();
      });
      //设置文件夹高亮
      this.$EventBus.$off("setFolderHighlight");
      this.$EventBus.$on("setFolderHighlight",function(data){
        self.$nextTick(()=>{
          self.$refs.folderTree.setCurrentKey(data);
        });
      })
    }
  },
  mounted(){
    // let self = this;
    // (function (api, enums, pms) {
    //   api.Folder.getFolderList({}, function (res) {
    //     console.log(res)
    //     const list = res.data.data.mailFolders;
    //     self.$store.commit('SET_FOLDERS',list);
    //     self.form.folders = self.$store.getters.folders;
    //     let folderList = self.filterFolderMenu(list, 0);
    //     self.folderList = folderList;
    //   })
    // })(xmail.api, xmail.enums, xmail.pms);

    let self = this;
    //初始化文件夹事件总线
    this.$EventBus.$off("getInitFolder");
    this.$EventBus.$on("getInitFolder",function(){
      self.initFolder();
    });
    if (storeLocal.get('Pwm-Islogin') && !Cookies.get('Pwm-userInfo-sso')) {
      this.initFolder()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sub/Folders.vue